import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { onFirewallAdditionalClick } from 'pages/Internet/store/actions';
import { getPricePeriod } from 'pages/Home/selectors';
import {
  getFTTBFirewallService,
  getIsFirewallLoading,
} from 'pages/Internet/store/selectors/firewallSelectors';
import { ServiceAdditional, ServiceCard, ServicePrice, ServiceSwitch, ServiceTitle } from '../../components';

export const FirewallCard = compose(connect((state) => ({
  shouldRender: !!getFTTBFirewallService(state).title,
})), withRenderFlag)(ServiceCard);

FirewallCard.Title = compose(
  connect((state) => ({
    title: getFTTBFirewallService(state).title,
    shouldRender: getFTTBFirewallService(state),
  })),
  withRenderFlag,
)(ServiceTitle);

FirewallCard.Switch = connect((state) => ({
  checked: getFTTBFirewallService(state).isChecked,
  isLoading: getIsFirewallLoading(state),
  disabled: true,
}))(ServiceSwitch);

FirewallCard.Additional = connect((state) => ({
  children: getFTTBFirewallService(state).additionalInformation,
}),
{
  onClick: onFirewallAdditionalClick,
})(ServiceAdditional);

FirewallCard.Price = connect((state) => ({
  price: getFTTBFirewallService(state).price,
  pricePeriod: getPricePeriod(state),
}))(ServicePrice);
